import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AutoRouter } from './components/auto-router'
import { Header } from './components/header/header';
import { MobileFooter } from './components/mobile-footer'
import { AppRoutes } from './components/app-routes'
import { VersionDisplay } from './components/version-display'
import { ScrollToTop } from './components/scroll-to-top'
import { PageTransition } from './components/page-transition'



function App() {
	return (
		<BrowserRouter>
			<ScrollToTop />
			<AutoRouter>
				<Header />
				<div
					className='min-h-screen pb-10'
					style={{ backgroundColor: 'hsl(var(--background))', color: 'hsl(var(--foreground))' }}>
					<main className='pb-10 mt-[var(--header-height)] h-[calc(100vh-var(--header-height))] overflow-x-hidden overflow-y-scroll pt-10'>
						<PageTransition>
							<AppRoutes />
						</PageTransition>
					</main>

					<MobileFooter />
					<VersionDisplay />
				</div>
			</AutoRouter>
			<Toaster position="top-right" />
		</BrowserRouter>
	);
}

export default App